export default __webpack_public_path__ + "static/media/11.cec76571.jpg";